<div class="copy-config-wrapper">
  <div class="header">
    <h3 class="title">
      <ng-container *ngIf="selectedCopiedConfiguration; else emptyTitle">
        {{ 'sources.configuration.copyFrom' | translate }} : {{ getSelectedConfigurationName() }}
      </ng-container>

      <ng-template #emptyTitle>
        {{ 'sources.configuration.copyConfigSelectDataSource' | translate }}
      </ng-template>
    </h3>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="content-wrapper">
    <div class="content">
      <ng-container *ngIf="selectedCopiedConfiguration; else configurationList">
        <mee-copy-config-options-window
          [destinationSource]="copyConfigData.destinationDataSource"
          [destinationConfiguration]="copyConfigData.destinationConfiguration"
          [copyConfigurationType]="copyConfigurationType"
          [copiedSourceConfiguration]="selectedCopiedConfiguration"
          (close)="onClose()"
          (back)="onBack()"
        ></mee-copy-config-options-window>
      </ng-container>

      <ng-template #configurationList>
        <mee-configuration-copy-list
          (onSelectConfiguration)="onSelectConfiguration($event)"
          [copyConfigurationList]="copyConfigurationsList">
        </mee-configuration-copy-list>
      </ng-template>
    </div>
  </div>
</div>
